import { SettlementAccount } from "../../types/aso.ebi";
import { generateAPI } from "../api.generator";

export const getSettlementAccount = generateAPI<
  {
    query: { weddingID: string };
  },
  SettlementAccount
>("get", "aso-ebi/settlement-account");
